import { render, staticRenderFns } from "./ConsolidationUnionCreateLabelAdmin.vue?vue&type=template&id=954d101c&scoped=true"
import script from "./ConsolidationUnionCreateLabelAdmin.vue?vue&type=script&lang=js"
export * from "./ConsolidationUnionCreateLabelAdmin.vue?vue&type=script&lang=js"
import style0 from "./ConsolidationUnionCreateLabelAdmin.vue?vue&type=style&index=0&id=954d101c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "954d101c",
  null
  
)

export default component.exports